module.exports = __webpack_public_path__ + "static/img/start.699aaf00.png";